// extracted by mini-css-extract-plugin
module.exports = {"card":"ProjectCard_card__2ztN2","imageGallery":"ProjectCard_imageGallery__13WXs","projectlink":"ProjectCard_projectlink__3E5NY","desc":"ProjectCard_desc__38GeQ"};